import useObjectSearchParams from 'hooks/useObjectSearchParams';
import useSetDeleteURLParams from 'hooks/useSetDeleteURLParams';

interface UserCertificatesFilterParams {
  search: string;
  onlyExpired: boolean;
  tagIds: string;
  projectIds: string;
}

const useUserCertificatesFilters = () => {
  const { search, onlyExpired, tagIds, projectIds } =
    useObjectSearchParams<UserCertificatesFilterParams>();

  const { setURLParam, deleteURLParam } =
    useSetDeleteURLParams<UserCertificatesFilterParams>();

  return {
    search,
    onlyExpired,
    tagIds,
    projectIds,
    setURLParam,
    deleteURLParam,
  };
};

export default useUserCertificatesFilters;
